import React from "react";
import { observer } from "mobx-react";
import { TenantTypeCreateStore } from "../../store";
import { TenantTypeCreateForm } from "./TenantTypeCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type TenantTypeCreateProps = {
  tenantTypeCreateStore: TenantTypeCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TenantTypeCreate: React.FC<TenantTypeCreateProps> = observer(
  ({ tenantTypeCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={tenantTypeCreateStore.isSaving} />
        <TenantTypeCreateForm
          tenantTypeCreateStore={tenantTypeCreateStore}
          name_esError={tenantTypeCreateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            tenantTypeCreateStore.setName_esValue(value);
          }}
          name_es={tenantTypeCreateStore.entityValues.name_es}
          name_enError={tenantTypeCreateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            tenantTypeCreateStore.setName_enValue(value);
          }}
          name_en={tenantTypeCreateStore.entityValues.name_en}
          name_ptError={tenantTypeCreateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            tenantTypeCreateStore.setName_ptValue(value);
          }}
          name_pt={tenantTypeCreateStore.entityValues.name_pt}
          description_esError={
            tenantTypeCreateStore.errors.description_es?.message
          }
          onDescription_esChange={(value: string) => {
            tenantTypeCreateStore.setDescription_esValue(value);
          }}
          description_es={tenantTypeCreateStore.entityValues.description_es}
          description_enError={
            tenantTypeCreateStore.errors.description_en?.message
          }
          onDescription_enChange={(value: string) => {
            tenantTypeCreateStore.setDescription_enValue(value);
          }}
          description_en={tenantTypeCreateStore.entityValues.description_en}
          description_ptError={
            tenantTypeCreateStore.errors.description_pt?.message
          }
          onDescription_ptChange={(value: string) => {
            tenantTypeCreateStore.setDescription_ptValue(value);
          }}
          description_pt={tenantTypeCreateStore.entityValues.description_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={tenantTypeCreateStore.isProcessing}
          onSave={() => tenantTypeCreateStore.saveNewTenantType()}
          onCancel={() => tenantTypeCreateStore.cancelNewTenantType()}
        />
        <ErrorDialog
          open={tenantTypeCreateStore.errorDialogOpened}
          title={tenantTypeCreateStore.errorTitle}
          description={tenantTypeCreateStore.errorDescription}
          onClose={() => tenantTypeCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
